// یک شناسه‌ی یکتا برای همین تب (هر بار لود صفحه جدید تولید میشه مگر رفرش باشه)
const TAB_KEY_PREFIX = 'app_tab_';
const HEARTBEAT_INTERVAL = 5000; // هر ۵ ثانیه
const STALE_THRESHOLD = 15000; // اگه ۱۵ ثانیه heartbeat نیومد، تب رو مرده در نظر بگیر

// آیا همین تب قبلاً باز بوده (رفرش) یا کاملاً تازه است؟
let tabId = sessionStorage.getItem('tab_id');
const isRefresh = !!tabId;
if (!tabId) {
    tabId = TAB_KEY_PREFIX + Date.now() + '_' + Math.random().toString(36).slice(2);
    sessionStorage.setItem('tab_id', tabId);
}

// پاکسازی کلیدهای تب‌های مرده (کرش‌کرده/بسته‌شده بدون cleanup) از localStorage
function pruneDeadTabs() {
    const now = Date.now();
    for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i);
        if (key && key.startsWith(TAB_KEY_PREFIX)) {
            const ts = parseInt(localStorage.getItem(key) || '0');
            if (now - ts > STALE_THRESHOLD) {
                localStorage.removeItem(key);
            }
        }
    }
}

// شمارش تب‌های واقعاً زنده
function countLiveTabs() {
    let count = 0;
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith(TAB_KEY_PREFIX)) count++;
    }
    return count;
}

// اگر تب کاملاً جدید است (نه رفرش)، اول ببینیم قبل از ثبت خودمان، تب زنده‌ای وجود داشته یا نه
if (!isRefresh) {
    pruneDeadTabs();
    const otherLiveTabs = countLiveTabs();
    if (otherLiveTabs === 0) {
        // یعنی هیچ تب زنده‌ای نبوده => مرورگر کاملاً بسته و تازه باز شده
        const shouldLogoutOnClose = localStorage.getItem('logoutOnClose') === 'true';
        if (shouldLogoutOnClose) {
            localStorage.removeItem('token');
            localStorage.removeItem('userData');
        }
    }
}

// ثبت/به‌روزرسانی این تب با timestamp فعلی
localStorage.setItem(tabId, Date.now().toString());

// heartbeat: هر چند ثانیه یک‌بار تایم‌استمپ خودمان را تازه می‌کنیم
const heartbeatId = setInterval(() => {
    localStorage.setItem(tabId, Date.now().toString());
}, HEARTBEAT_INTERVAL);

// وقتی تب بسته یا رفرش می‌شود، کلید خودمان را حذف می‌کنیم (بدون تداخل با تب‌های دیگر)
let hasUnloaded = false;
const handleUnload = () => {
    if (hasUnloaded) return;
    hasUnloaded = true;
    clearInterval(heartbeatId);
    localStorage.removeItem(tabId);
};
window.addEventListener('beforeunload', handleUnload);
window.addEventListener('pagehide', handleUnload);
